import React from 'react';
import { Text } from '@chakra-ui/react';

const PreviewStepModal = props => (
  <Text textStyle="displayXs600">Coming Soon</Text>
);

export default PreviewStepModal;
